export const widgetTelemetrySessions = {
    namespaced: true,

    state: {
        selectedSquad: null
    },

    getters: {
        selectedSquad(state) {
            return state.selectedSquad;
        }
    },

    mutations: {
        reset(state) {
            state.selectedSquad = null;
        },
        updateSelectedSquad(state, squad) {
            state.selectedSquad = squad;
        }
    }
};

export default widgetTelemetrySessions;
